import { render, staticRenderFns } from "./mail-list.vue?vue&type=template&id=c577dde8&scoped=true&"
import script from "./mail-list.vue?vue&type=script&lang=js&"
export * from "./mail-list.vue?vue&type=script&lang=js&"
import style0 from "./mail-list.vue?vue&type=style&index=0&id=c577dde8&lang=scss&scoped=true&"
import style1 from "./mail-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c577dde8",
  null
  
)

export default component.exports